import { gql, graphQueryBang } from "shared/lib/graphql"

const liveAppletDestroyGQL = gql`
  mutation($slug: String!) {
    liveAppletDestroy(input: { applet_id: $slug }) {
      errors {
        attribute
        message
      }
      normalized_applet {
        id
        archived
      }
    }
  }
`

const appletDetails = gql`
  applet_trigger {
    fields {
      name
      hidden
    }

    step: trigger {
      name
      module_name
      full_module_name
      normalized_module_name

      service: channel {
        id
        name
        normalized_module_name
        module_name
      }

      fields: trigger_fields {
        label
        name
        field_ui_type
        normalized_field_type
        required
        shareable
        hideable
        can_have_default
        helper_text
      }
      ingredients {
        label
        name
        example
        value_type
      }
    }
  }

  applet_queries {
    fields {
      name
      hidden
    }

    step: query {
      name
      module_name
      full_module_name
      normalized_module_name

      service: channel {
        id
        name
        normalized_module_name
        module_name
      }

      fields: query_fields {
        label
        name
        normalized_module_name
        field_ui_type
        normalized_field_type
        required
        shareable
        hideable
        can_have_default
        helper_text
      }
      ingredients {
        label
        name
        example
        value_type
      }
    }
  }

  applet_actions {
    fields {
      name
      hidden
    }

    step: action {
      name
      module_name
      full_module_name
      normalized_module_name

      service: channel {
        id
        name
        normalized_module_name
        module_name
      }
      fields: action_fields {
        label
        name
        normalized_module_name
        field_ui_type
        normalized_field_type
        required
        shareable
        hideable
        can_have_default
        helper_text
      }
    }
  }
`

// Only owner should access filter code
const filterCodeOwnerGQL = gql`
  query($applet_id: String!) {
    applet(id: $applet_id, in_embed_view: true) {
      filterCode: filter_code
      ${appletDetails}
    }
  }
`

const filterCodeGQL = gql`
  query($applet_id: String!) {
    applet(id: $applet_id, in_embed_view: true) {
      ${appletDetails}
    }
  }
`

export const deleteLiveAppletMutation = slug =>
  graphQueryBang(liveAppletDestroyGQL, { slug })

export const filterCodeQuery = (appletId, isOwner) => {
  const gqlQuery = isOwner ? filterCodeOwnerGQL : filterCodeGQL

  return graphQueryBang(gqlQuery, { applet_id: appletId })
}
